<template>
	<div
		class="g-block-divider-double-thick-top g-block-divider-padding"
		:class="{
			'g-block-divider-double-thick-top--edit': editable,
			'is-active': editable && active,
			'g-block-divider-double-thick-top--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-divider-double-thick-top__lines">
			<span
				class="g-block-divider-double-thick-top__line g-block-divider-double-thick-top__line--thick"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></span>
			<span
				class="g-block-divider-double-thick-top__line g-block-divider-double-thick-top__line--thin"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></span>
		</div>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerDoubleThickTop',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';

	.g-block-divider-double-thick-top {
		.divider-block-edit-shell();
	}

	.g-block-divider-double-thick-top__lines {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.g-block-divider-double-thick-top__line {
		display: block;
		width: 100%;

		&--thin {
			height: 1px;
		}

		&--thick {
			height: 3px;
		}
	}

	.g-block-divider-double-thick-top--h5 {
		.g-block-divider-double-thick-top__lines {
			gap: 0.12rem;
		}

		.g-block-divider-double-thick-top__line--thin {
			height: 0.02rem;
		}

		.g-block-divider-double-thick-top__line--thick {
			height: 0.06rem;
		}
	}
</style>
